module.exports = __webpack_public_path__ + "assets/img/Travel_004.890a5db9-ps.jpg";